import {HttpClient, HttpHandler} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import CallbackRequestCard from '../../interfaces/card/requests/CallbackRequestCard';
import { BinLookupRequest } from 'src/app/interfaces/card/requests/bin-lookup-request';
import { BinLookupResponse } from 'src/app/interfaces/card/responses/bin-lookup-response';

@Injectable()
export class CardApi extends HttpClient {
  private baseUrl = environment.production ? '/channel-virtual/api/v1' + '/card' : environment.baseUrl + '/card';

  // private baseUrlTokenization = environment.production ? '/channel-virtual/api/v1' + '/tokenization' : environment.baseUrl + '/tokenization';

  public constructor(handler: HttpHandler) {
    super(handler);
  }

  public initiateTransaction(type: string, body, sessionToken): Observable<object> {
    let url = '';
    if (type === 'tokenized') {
      url = this.baseUrl + `/initialise/tokenized?sessionToken=${sessionToken}`;
    } else {
      url = this.baseUrl + `/initialise?sessionToken=${sessionToken}`;
    }
    return super.post(url, body);
  }

  public initiateInstalmentTransaction(type: string, body, sessionToken): Observable<object> {
    let url = '';
    if (type === 'tokenized') {
      url = this.baseUrl + `/plans/tokenized?sessionToken=${sessionToken}`;
    } else {
      url = this.baseUrl + `/plans?sessionToken=${sessionToken}`;
    }
    return super.post(url, body);
  }

  public authoriseTransaction(sessionToken): Observable<object> {
    const url = this.baseUrl + `/authorise/${sessionToken}`;
    return super.get(url);
  }

  public deleteCard(cardToken: string, sessionToken: string): Observable<any> {
    const url = `${this.baseUrl}/delete/${cardToken}/${sessionToken}`;
    return super.get(url);
  }

  public callback(body: CallbackRequestCard): Observable<object> {
    const url = this.baseUrl + `/callback`;
    return super.post(url, body);
  }

  public verifyCard(body, sessionToken): Observable<object> {
    let url = this.baseUrl + `/verify?sessionToken=${sessionToken}`;
    return super.post(url, body);
  }

  public initiateGooglePayTransaction(body, sessionToken) {
      let url = '';
      // if (type === 'tokenized') {
      // url = this.baseUrl + `/initialise/tokenized?sessionToken=${sessionToken}`;
    // } else {
      url = this.baseUrl + `/initialise/google-pay?sessionToken=${sessionToken}`;
    // }
    return super.post(url, body);
  }

  initiateApplePayTransaction(body, sessionToken) {
    let url = '';
    url = this.baseUrl + `/initialise/apple-pay?sessionToken=${sessionToken}`;
    return super.post(url, body);
  }

  public binLookup(request: BinLookupRequest) {
    let url = this.baseUrl + '/bin/lookup';
    return super.post(url, request);
  }
}
